module.exports = __webpack_public_path__ + "static/media/exhibition-hall.3ee94a04.jpg";